import { AUTHORIZATION_HEADER } from '../../../../../../../../src/authorization';
import { send } from '../../../../../../../../src/network';
import { type PlanServicePlanComponents } from '../../../../../../../../src/types/PlanServicePlanComponents';

export type PlanServiceCustomerPlanParams = {
  is_staged?: 0 | 1;
};

export const getPlanServiceCustomerPlanPath = ({
  is_staged,
}: PlanServiceCustomerPlanParams) => {
  return `/api/v2/plan_service/customers/self/plans/view/${
    is_staged !== undefined ? `?is_staged=${is_staged}` : ''
  }`;
};

export async function getPlanServiceCustomerPlan(
  params: PlanServiceCustomerPlanParams
) {
  return await send<PlanServicePlanComponents>({
    method: 'GET',
    path: getPlanServiceCustomerPlanPath(params),
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
